export const commonStyles = (theme: any) => ({
  mt1: {
    marginTop: theme.spacing(1),
  },
  mt2: {
    marginTop: theme.spacing(2),
  },
  mt3: {
    marginTop: theme.spacing(3),
  },
  mb1: {
    marginBottom: theme.spacing(1),
  },
  mb2: {
    marginBottom: theme.spacing(2),
  },
  mb3: {
    marginBottom: theme.spacing(3),
  },
  ml1: {
    marginLeft: theme.spacing(1),
  },
  ml2: {
    marginLeft: theme.spacing(2),
  },
  ml3: {
    marginLeft: theme.spacing(3),
  },
  mr1: {
    marginRight: theme.spacing(1),
  },
  mr2: {
    marginRight: theme.spacing(2),
  },
  mr3: {
    marginRight: theme.spacing(3),
  },
  spacing4: {
    padding: theme.spacing(4),
  },
});
